import { LAYERING_MODE_BEST, LAYERING_MODE_SURPRISE } from '../../lib/layeringModes'

const modes = [
  { value: LAYERING_MODE_BEST, label: 'BEST MATCHES' },
  { value: LAYERING_MODE_SURPRISE, label: 'SURPRISE ME', sparkle: true },
]

export default function LayeringModeToggle({ mode = LAYERING_MODE_BEST, onModeChange }) {
  return (
    <div className="flex flex-wrap justify-center gap-2" aria-label="Layering recommendation mode" data-layering-mode-toggle>
      {modes.map(option => {
        const active = mode === option.value
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            data-layering-mode={option.value}
            onClick={() => onModeChange?.(option.value)}
            className={`min-h-11 rounded-full border px-4 py-2 text-[11px] font-semibold tracking-[0.12em] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${
              active
                ? 'border-gold bg-gold text-charcoal-900'
                : 'border-gold/35 bg-transparent text-gold hover:border-gold/65 hover:text-cream'
            }`}
          >
            {option.sparkle && <><span aria-hidden="true">✦</span>{' '}</>}
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
